@if (_context) {
    <mat-tab-group class="detail-tabs">
        <mat-tab label="Infos">
            <app-article-form
                [disabled]="_context.formMode === FormMode.Reading"
                [context]="_context.formContext"
                [article]="_context.formContext.item"
                (articleUpdated)="onArticleUpdated($event)"
                (canceled)="onCanceled($event)"></app-article-form>
        </mat-tab>
        @if (!!_context.formContext.item.id) {
            <mat-tab label="Alias">
                <app-article-alias-form [context]="_context.formContext" (articleUpdated)="onArticleUpdated($event)" (canceled)="onCanceled($event)"></app-article-alias-form>
            </mat-tab>
        }
    </mat-tab-group>
}
